import {
    TicketContent,
    TicketContentText,
    TicketSubtitle,
} from '../../common/components/ticketplus/TicketPlusLayout';
import {
    ticketExitedForFreeMessage,
    ticketExitedForFreeTitle,
} from '../../common/components/ticketplus/TicketPlusModalTexts';
import { isRunningInNativeWrapper } from '../../Native.ts';
import {
    FullWidthBottomButton,
    FullWidthBottomButtonColor,
} from '../../common/components/FullWidthBottomButton.tsx';
import { useNavigate } from 'react-router-dom';

export const QuickCheckoutFlowTicketExitedForFree = () => {
    const navigate = useNavigate();
    return (
        <TicketContent>
            <TicketSubtitle>{ticketExitedForFreeTitle}</TicketSubtitle>
            <TicketContentText>{ticketExitedForFreeMessage}</TicketContentText>
            {isRunningInNativeWrapper() && (
                <FullWidthBottomButton
                    color={FullWidthBottomButtonColor.WHITE}
                    onClick={() => navigate('/')}
                    label={{
                        de: 'Schliessen',
                        fr: 'Fermer',
                        it: 'Chiudi',
                        en: 'Close',
                    }}
                />
            )}
        </TicketContent>
    );
};
